import { create } from "zustand";

const LS_KEY = "routera:material_stops";
const LS_CONFIRMED_KEY = "routera:material_confirmed";

function load(): string[] {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) ?? "[]");
  } catch {
    return [];
  }
}

function loadConfirmed(): boolean {
  return localStorage.getItem(LS_CONFIRMED_KEY) === "1";
}

function save(ids: string[]) {
  localStorage.setItem(LS_KEY, JSON.stringify(ids));
}

interface MaterialState {
  markedIds: string[];
  totalForToday: number;
  confirmedToday: boolean;
  toggle: (stopId: string) => void;
  setTotal: (n: number) => void;
  setConfirmedToday: () => void;
  clear: () => void;
}

export const useMaterialStore = create<MaterialState>((set, get) => ({
  markedIds: load(),
  totalForToday: 0,
  confirmedToday: loadConfirmed(),
  toggle: (stopId) => {
    const cur = get().markedIds;
    const next = cur.includes(stopId)
      ? cur.filter((id) => id !== stopId)
      : [...cur, stopId];
    save(next);
    set({ markedIds: next });
  },
  setTotal: (n) => set({ totalForToday: n }),
  setConfirmedToday: () => {
    localStorage.setItem(LS_CONFIRMED_KEY, "1");
    set({ confirmedToday: true });
  },
  clear: () => {
    save([]);
    localStorage.removeItem(LS_CONFIRMED_KEY);
    set({ markedIds: [], totalForToday: 0, confirmedToday: false });
  },
}));
